module.exports = __webpack_public_path__ + "img/chinesecompany79.f35eb877.png";